import esupplyvetApi from "./esupplyvet";
import api from "./index";
import { useRegisterStore } from "@/stores/register";

function getHttpClient() {
  const registerStore = useRegisterStore();
  const userRole = registerStore.user?.role || "";
  return userRole === "client" ? esupplyvetApi : api;
}

/**
 * Récupère la liste des types d'animaux disponibles
 * @returns {Promise} Response avec la liste des types d'animaux
 */
export const getAnimalTypes = () => {
  return getHttpClient().get("/animal-types");
};

/**
 * Inscription à la newsletter
 * @param {Object} data - Données d'inscription
 * @param {string} data.email - Email de l'utilisateur
 * @param {number[]} data.animalTypeIds - IDs des types d'animaux sélectionnés
 * @returns {Promise} Response de l'inscription
 */
export const subscribeNewsletter = data => {
  return getHttpClient().post("/newsletter/subscribe", data);
};
